module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-sheet', [_c('v-card', {
    staticClass: "text-center my-0 pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    staticClass: "text-center my-0 pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 mb-0 mx-0 subtitle-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-card', {
    class: _vm.dense ? 'mx-1' : 'mx-2',
    attrs: {
      "outlined": ""
    }
  }, [_c('v-list', {
    class: [_vm.currentBbr === _vm.bbr.id ? 'grey lighten-2' : '', _vm.dense ? 'pa-0' : ''],
    attrs: {
      "dense": "",
      "width": _vm.kachelbreite
    }
  }, [_c('v-list-item', {
    staticClass: "px-1"
  }, [_c('v-list-item-content', {
    staticClass: "text-truncate py-1"
  }, [_c('v-list-item-title', [(_vm.bbr.titel) ? _c('span', {
    staticClass: "pr-1"
  }, [_vm._v(_vm._s(_vm.bbr.titel))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.bbr.nachname) + ", " + _vm._s(_vm.bbr.vorname) + "\n                ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                  rec. " + _vm._s(_vm.$filters.date(_vm.bbr.receptionsdatum, "DD.MM.YYYY")) + "\n                ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer')], 1)], 1), _vm._v(" "), (_vm.sohn.length > 0) ? _c('svg', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "id": "svg",
      "width": "100%",
      "height": _vm.svgHeight
    }
  }, [(_vm.kanten.length > 0) ? _c('g', _vm._l((_vm.kanten), function(item, index) {
    return _c('path', {
      key: index,
      attrs: {
        "d": 'M' +
          item.x1 +
          ' ' +
          item.y1 +
          ' C ' +
          item.x1 +
          ' ' +
          item.y2 +
          ' ' +
          item.x2 +
          ' ' +
          item.y1 +
          ' ' +
          item.x2 +
          ' ' +
          item.y2 +
          '',
        "stroke": "lightgrey",
        "stroke-width": "1",
        "fill": "none"
      }
    })
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sohn.length > 0) ? _c('v-card', {
    staticClass: "d-flex justify-center ma-0",
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.sohn), function(node, index) {
    return _c('stammbaumKnoten', {
      key: index,
      staticClass: "mt-n2",
      attrs: {
        "sohn": node.sohn,
        "bbr": node.bbr,
        "blatter": node.blatter,
        "ebene": _vm.ebene + 1,
        "currentBbr": _vm.currentBbr,
        "dense": _vm.dense,
        "kachelbreite": _vm.kachelbreite
      }
    })
  }), 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fcaea0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/stammbaumKnoten.vue
// module id = 776
// module chunks = 15